import React from 'react';
import { ButtonLink } from '../ui/ButtonLink';
import { HeroDashboard } from '../scenes/hero/HeroDashboard';
import { DEMO_CENTER_URL } from '../../data/navigation';
export function HomeHero() {
  return <section className="relative overflow-hidden pb-24 pt-14 md:pb-32 md:pt-20" data-id="element-33" data-mp="24693fnizw1z7">
      <div className="bg-dots pointer-events-none absolute inset-x-0 bottom-0 top-[42%]" aria-hidden="true" data-id="element-34" data-mp="2940wwlzafw5i" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8" data-id="element-35" data-mp="2wtv86z3ylcnn">
        <div className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="2wwhiv7m5c8a3">
          <p className="text-xs font-semibold tracking-[0.14em] text-accent" data-id="element-37" data-mp="31rwtlqouxo2a">NOETIVRA BY SYNEURAL</p>
          <h1 className="mt-5 text-[44px] font-semibold leading-[1.02] tracking-display sm:text-6xl md:text-7xl" data-id="element-38" data-mp="2n3io18023li1">
            Connected knowledge.
            <br data-id="element-39" data-mp="3fszh87vi36fb" />
            <span className="text-ink-soft" data-id="element-40" data-mp="3fsha2g7av7sm">Clear insight.</span>
            <br data-id="element-41" data-mp="3fr688lxf0a45" />
            Intuitive control.
          </h1>
          <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-42" data-mp="3kkhgmrhvkyy6">
            Noetivra brings connected knowledge, assessments, services, and operational tools into one intuitive software
            environment—with configurable workspaces for institutions, teams, and the people they serve.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-43" data-mp="xpdp07wtwffu">
            <ButtonLink to="/workspaces" data-id="element-44" data-mp="suzmlljr181o">Explore Workspaces</ButtonLink>
            <ButtonLink href={DEMO_CENTER_URL} variant="secondary" icon="external" data-id="element-45" data-mp="17k5lf8eocw91">
              Try an Interactive Demo
            </ButtonLink>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-6xl md:mt-20" data-id="element-46" data-mp="1gldhdjtpxkzy">
          <HeroDashboard data-id="element-47" data-mp="1cktkmhd24jec" />
        </div>
      </div>
    </section>;
}